import { LoadablePaint } from '@confluence/loadable';

export const NewContentHistory = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-NewContentHistory" */ '../src/NewContentHistory.tsx'))
			.NewContentHistory,
});
